import React from "react";
import Icon from "../../../components/AppIcon";

const ServiceJourney = () => {
  const journeySteps = [
    {
      id: 1,
      icon: "UserCheck",
      title: "Consulta Inicial",
      description:
        "Evaluación gratuita de tu propiedad y necesidades energéticas",
      duration: "1-2 días",
      features: [
        "Análisis de consumo eléctrico",
        "Evaluación estructural del techo",
        "Cálculo de potencial solar",
        "Propuesta personalizada",
      ],
    },
    {
      id: 2,
      icon: "PenTool",
      title: "Diseño Personalizado",
      description: "Creación de sistema solar optimizado para tu propiedad",
      duration: "1-2 días",
      features: [
        "Modelado del sistema",
        "Optimización de rendimiento",
        "Selección de componentes",
        "Simulación de producción",
      ],
    },
    {
      id: 3,
      icon: "Wrench",
      title: "Instalación Profesional",
      description: "Montaje e instalación por técnicos certificados",
      duration: "1-5 días",
      features: [
        "Instalación de paneles",
        "Conexión eléctrica",
        "Sistema de monitoreo",
        "Pruebas de funcionamiento",
      ],
    },
    {
      id: 4,
      icon: "Shield",
      title: "Activación y Garantía",
      description: "Puesta en marcha ",
      duration: "1 día",
      features: [
        "Activación del sistema",
        "Registro de usuario",
        "Control de consumo",
      ],
    },
    {
      id: 5,
      icon: "FileText",
      title: "Permisos y Trámites",
      description: "Gestión completa de permisos",
      duration: "1-3 semanas",
      features: [
        "Permisos municipales",
        "Interconexión con Empresa eléctrica",
        "Trámite para el cambio de contador",
      ],
    },
    {
      id: 6,
      icon: "Settings",
      title: "Mantenimiento Continuo",
      description: "Soporte técnico y mantenimiento ",
      duration: "Permanente",
      features: [
        "Monitoreo 24/7 en línea",
        "Mantenimiento preventivo",
        "Limpieza de paneles",
        "Soporte técnico",
      ],
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50/50 overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20 relative">
          <div className="inline-flex items-center space-x-2 bg-primary/5 rounded-full px-4 py-2 mb-6 border border-primary/10">
            <Icon name="Activity" size={16} className="text-primary" />
            <span className="text-primary text-xs font-bold uppercase tracking-wider">
              Nuestra Metodología
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-6">
            Tu Viaje Hacia la <span className="solar-text-gradient">Independencia Energética</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto leading-relaxed">
            Un proceso de ingeniería riguroso y transparente diseñado para garantizar que tu transición al sol sea impecable, desde el diseño hasta el mantenimiento vitalicio.
          </p>
        </div>

        {/* Journey Steps Grid */}
        <div className="grid lg:grid-cols-2 gap-8 mb-20">
          {journeySteps?.map((step) => (
            <div
              key={step?.id}
              className="group bg-white rounded-3xl p-8 border border-gray-100 solar-shadow-card solar-hover-lift relative overflow-hidden transition-all duration-300 hover:border-primary/20 hover:shadow-2xl"
            >
              {/* Side accent bar */}
              <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-primary/10 group-hover:bg-primary transition-colors"></div>

              <div className="flex items-start gap-6 mb-8">
                <div className="w-16 h-16 bg-primary/5 rounded-2xl flex-shrink-0 flex items-center justify-center text-primary transition-all duration-300 group-hover:bg-primary group-hover:text-white group-hover:scale-110 shadow-sm">
                  <Icon
                    name={step?.icon}
                    size={32}
                    strokeWidth={1.5}
                  />
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-primary/40 font-black text-2xl group-hover:text-primary/20 transition-colors">
                      {String(step?.id).padStart(2, '0')}
                    </span>
                    <h3 className="text-2xl font-bold text-text-primary group-hover:text-primary transition-colors">
                      {step?.title}
                    </h3>
                  </div>
                  <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-success/10 text-success text-[10px] font-bold uppercase tracking-wider">
                    <Icon name="Clock" size={10} />
                    {step?.duration}
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <p className="text-text-secondary leading-relaxed text-sm lg:text-base">
                  {step?.description}
                </p>

                <div className="bg-gray-50/50 rounded-2xl p-6 border border-gray-100/50">
                  <h4 className="text-xs font-bold text-text-primary uppercase tracking-widest mb-4 flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary"></div>
                    Detalles del Proceso
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {step?.features?.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2.5">
                        <Icon
                          name="CheckCircle"
                          size={14}
                          className="text-success mt-0.5 flex-shrink-0 opacity-70"
                        />
                        <span className="text-text-secondary text-xs lg:text-sm font-medium">
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceJourney;
